var render = function (_h,_vm) {var _c=_vm._c;return _c('router-link',{staticClass:"link primary edit-employee-button",attrs:{"to":("/employees/" + (_vm.props.id))}},[_vm._v(" "+_vm._s(_vm.parent.$t(_vm.parent.editable ? 'edit' : 'show'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }